var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7036 0.948619C11.7036 2.79945 13.2062 4.29984 15.0598 4.29984C15.2639 4.29883 15.4674 4.27924 15.668 4.2413V10.8852C15.668 13.6803 14.0192 15.334 11.22 15.334H5.12327C2.31672 15.334 0.667969 13.6803 0.667969 10.8852V4.7974C0.667969 2.00228 2.31672 0.333984 5.12327 0.333984H11.7623C11.7229 0.536488 11.7032 0.74233 11.7036 0.948619ZM9.95962 9.41447L12.3411 6.3413V6.32667C12.545 6.05271 12.493 5.6664 12.2239 5.45594C12.0937 5.35539 11.9281 5.31186 11.7652 5.33531C11.6022 5.35875 11.4558 5.44715 11.3592 5.58033L9.35141 8.16325L7.06514 6.36325C6.93461 6.26156 6.76856 6.21666 6.60448 6.23869C6.4404 6.26072 6.29212 6.34782 6.19313 6.48033L3.73099 9.65594C3.64444 9.76381 3.59785 9.89821 3.59909 10.0364C3.5848 10.3158 3.7612 10.5695 4.02828 10.6538C4.29537 10.7381 4.58578 10.6317 4.7349 10.395L6.79401 7.73154L9.08028 9.52423C9.21032 9.62906 9.37746 9.67659 9.5433 9.65589C9.70914 9.63519 9.85942 9.54805 9.95962 9.41447Z",
    fill: "#47536C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.7822d3fc7fe2e2320e731c8bd2523ed2.svg";
export { ForwardRef as ReactComponent };